<template>
  <div>
    <van-skeleton :row="3" :loading="loading">
      <div v-for="(img, i) in imgs" :key="i">
        <img :src="img.base64" :style="img.style" class="onlyPrintShow"/>
      </div>
    </van-skeleton>
  </div>
</template>

<script>
import * as PDFJS from 'pdfjs-dist'
import CMapReaderFactory from 'vue-pdf-signature/src/CMapReaderFactory.js'
PDFJS.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry')
export default {
  name: 'pdf',
  props: {
    src: {
      type: String,
      default: () => { return '' }
    }
  },
  components: {},
  created () { },
  async mounted () {
    this.loading = true
    await this.renderPDF()
    this.loading = false
  },
  computed: {},
  watch: { 
    src: {
      async handler () {
        this.loading = true
        await this.renderPDF()
        this.loading = false
      }
    }
  },
  data () {
    return {
      pdf: '',
      imgs: [],
      loading: false
    }
  },
  methods: {
    async loadPdf() {
      const loadingTask = pdfjsLib.getDocument(this.src);
      const pdf = await loadingTask.promise;
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = this.$refs.pdfCanvas;
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };
      page.render(renderContext);
    },
    async renderPDF () {
      // 加载 PDF 文件
      this.imgs = []
      const pdf = await PDFJS.getDocument({ url: this.src, CMapReaderFactory, cMapPacked: true }).promise
      const totalPage = pdf.numPages
      this.pdf = pdf
      const canvas = document.createElement('canvas')
      document.body.appendChild(canvas)
      for (let i = 1; i <= totalPage; i++) {
        const canvasA = await this._renderPage(name, i)
        this.imgs.push(canvasA)
      }
    },
    async _renderPage (name, currentPage) {
      const canvas = document.createElement('canvas')
      const page = await this.pdf.getPage(currentPage)
      const viewport = page.getViewport({ scale: 1.5 })
      canvas.width = viewport.width
      canvas.height = viewport.height
      const ctx = canvas.getContext('2d')
      await page.render({ canvasContext: ctx, viewport }).promise
      console.log()
      return {
        base64: canvas.toDataURL('image/png'),
        style: this.imgStyleControl(viewport)
      }
    },
    imgStyleControl (viewport) {
      return `width: 100%; height: auto;`
    }
  }
}
</script>

<style>
</style>
